import { gql } from "@apollo/client";

export const GET_LEGACY_FORM_TEMPLATE_RULE_BY_FORM_TEMPLATE_RULE_ID = gql`
  query GetLegacyFormTemplateRuleByFormTemplateId(
    $formTemplateId: uuid!
    $enrollmentPeriodId: uuid!
  ) {
    form_template(
      where: {
        enrollment_period_id: { _eq: $enrollmentPeriodId }
        deleted_at: { _is_null: true }
        id: { _neq: $formTemplateId }
      }
      order_by: [{ open_at: asc }]
    ) {
      id
      name
    }
    school(
      where: { grades: { enrollment_period_id: { _eq: $enrollmentPeriodId } } }
      order_by: [{ name: asc }]
    ) {
      id
      name
      grades {
        program {
          id
        }
      }
    }
    enrollment_period_tag(
      where: { enrollment_period_id: { _eq: $enrollmentPeriodId } }
      order_by: { name: asc }
    ) {
      id
      name
      tag_group {
        name
      }
    }
    form_template_by_pk(id: $formTemplateId) {
      sections {
        id
        type
        schools_ranking_section {
          ranking_enabled
        }
      }
      form_engine_rules {
        id
        form_template_id
        rule_type
        rule_config
        version
        active
        created_at
        updated_at
      }
      form_template_rule {
        id
        rules {
          id
          type
          status_rule {
            next_form_template_id
            next_step
            form_status
            offer_status
            type
            waitlist_status
            schools_operator
            schools {
              school {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_FORM_ENGINE_RULE_QUESTIONS = gql`
  query GetFormEngineRuleQuestions($formTemplateId: uuid!) {
    form_template_by_pk(id: $formTemplateId) {
      id
      sections(order_by: { order: asc }) {
        id
        questions(
          where: { type: { _in: [SingleSelect, MultiSelect, Grades, Address] } }
          order_by: { order: asc }
        ) {
          id
          type
          question
          grades_question {
            grades(order_by: { order: asc_nulls_first }) {
              grade_config {
                id
                label
                order
              }
            }
            grades_additional_questions(
              order_by: { question: { order: asc } }
            ) {
              question {
                id
                type
                question
                form_question {
                  form_question_options(order_by: { order: asc }) {
                    id
                    label
                    order
                  }
                }
              }
            }
          }
          form_question {
            form_question_options(order_by: { order: asc }) {
              id
              label
              order
              additional_questions(order_by: { question: { order: asc } }) {
                question {
                  id
                  type
                  question
                  form_question {
                    form_question_options(order_by: { order: asc }) {
                      id
                      label
                      order
                    }
                  }
                  grades_question {
                    grades(order_by: { order: asc_nulls_first }) {
                      grade_config {
                        id
                        label
                        order
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_BOUNDARIES_FOR_RULE_CONFIGURATION = gql`
  query GetBoundariesForRuleConfiguration($organizationId: uuid!) {
    boundaries: boundary(
      where: {
        organization_id: { _eq: $organizationId }
        name: { _is_null: false }
      }
    ) {
      id
      name
    }
  }
`;
